import { arrayWithoutSubset, setFulfilled, setPending, setRejected } from '@ms/yammer-data-support';
import type { Reducer } from 'redux';

import type {
  DesignateLeaderFulfilledAction,
  RevokeLeaderFulfilledAction,
  UserNetworkLeadersListLoadAction,
  UserNetworkLeadersListLoadMoreAction,
} from '../../domains/leadersManagement/actions.types';

import type { UserNetworkLeadersList, UserNetworkLeadersTable } from './types';

export type UserNetworkLeadersListAction =
  | UserNetworkLeadersListLoadAction
  | UserNetworkLeadersListLoadMoreAction
  | DesignateLeaderFulfilledAction
  | RevokeLeaderFulfilledAction;

const initialState: UserNetworkLeadersList = {
  pending: false,
  fulfilled: undefined,
  rejected: undefined,
};

const loadMoreFulfilledUserNetworkLeadersList = (
  state: UserNetworkLeadersList,
  userNetworkLeadersList: UserNetworkLeadersTable
) => {
  const currentUserNetworkLeadersIds = state.fulfilled?.userNetworkLeaders ?? [];

  return {
    ...state,
    fulfilled: {
      ...userNetworkLeadersList,
      userNetworkLeaders: [...currentUserNetworkLeadersIds, ...userNetworkLeadersList.userNetworkLeaders],
    },
  };
};

const stateWithDesignateLeaderFulfilled = (
  state: UserNetworkLeadersList,
  { userId }: DesignateLeaderFulfilledAction['payload']
): UserNetworkLeadersList => {
  const fulfilledState = state.fulfilled || {};
  const userNetworkLeaders = fulfilledState.userNetworkLeaders || [];

  return {
    ...state,
    fulfilled: {
      ...fulfilledState,
      userNetworkLeaders: [userId, ...userNetworkLeaders],
    },
  };
};

const stateWithRevokedLeaderFulfilled = (
  state: UserNetworkLeadersList,
  { userId: revokedLeader }: RevokeLeaderFulfilledAction['payload']
): UserNetworkLeadersList => {
  const fulfilledState = state.fulfilled || {};
  const userNetworkLeaders = fulfilledState.userNetworkLeaders || [];

  return {
    ...state,
    fulfilled: {
      ...fulfilledState,
      userNetworkLeaders: arrayWithoutSubset(userNetworkLeaders, [revokedLeader]),
    },
  };
};

const reducer: Reducer<UserNetworkLeadersList, UserNetworkLeadersListAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'ALL_LEADERS_IN_USERS_NETWORK.LOAD_PENDING':
      return setPending();
    case 'ALL_LEADERS_IN_USERS_NETWORK.LOAD_FULFILLED':
      return setFulfilled(action.payload.entities.userNetworkLeadersList);
    case 'ALL_LEADERS_IN_USERS_NETWORK.LOAD_MORE_FULFILLED':
      return loadMoreFulfilledUserNetworkLeadersList(state, action.payload.entities.userNetworkLeadersList);
    case 'ALL_LEADERS_IN_USERS_NETWORK.LOAD_REJECTED':
      return setRejected(action.payload.error);
    case 'DESIGNATE_LEADER.FULFILLED':
      return stateWithDesignateLeaderFulfilled(state, action.payload);
    case 'REVOKE_LEADER.FULFILLED':
      return stateWithRevokedLeaderFulfilled(state, action.payload);
    default:
      return state;
  }
};

export default reducer;
